import { type UpdateExpenseMileageConfigurationInputData } from '../../business-logic/types'
import { type ExpenseMileageConfigurationPayload } from '../types/ExpenseMileageConfigurationPayload'

export const mapUpdateExpenseMileageConfigurationInputDataToApi = (
  input: UpdateExpenseMileageConfigurationInputData
): ExpenseMileageConfigurationPayload => ({
  force_preset_rates: input.forcePresetRates,
  tax_type: input.taxType,
  default_mileage_preset: input.defaultMileagePreset,
})
